var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCsv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 21.75c0 .414.336.75.75.75H7.5V24H2.25A2.25 2.25 0 0 1 0 21.75V2.25A2.25 2.25 0 0 1 2.25 0h12c.2 0 .39.077.533.217l4.5 4.5c.14.142.218.334.217.533v3H18V6h-3a1.5 1.5 0 0 1-1.5-1.5v-3H2.25a.75.75 0 0 0-.75.75v19.5zm12-8.25a.75.75 0 0 0 0 1.5H15a2.25 2.25 0 1 1 0 4.5h-1.5a2.25 2.25 0 0 1-2.25-2.25h1.5c0 .414.336.75.75.75H15a.75.75 0 0 0 0-1.5h-1.5a2.25 2.25 0 1 1 0-4.5H15a2.25 2.25 0 0 1 2.25 2.25h-1.5a.75.75 0 0 0-.75-.75h-1.5zm-6 0A1.5 1.5 0 0 0 6 15v1.5a1.5 1.5 0 0 0 3 0h1.5a3 3 0 1 1-6 0V15a3 3 0 1 1 6 0H9a1.5 1.5 0 0 0-1.5-1.5zm15-1.5H24v4.5c0 1.657-1.815 3-3 3s-3-1.343-3-3V12h1.5v4.5c0 .81 1.14 1.5 1.5 1.5.36 0 1.5-.69 1.5-1.5V12z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.11b862d319041b45635ae975eef7d380.svg";
export { ForwardRef as ReactComponent };